export default "__VITE_ASSET__w1QG2pP1__"